import { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

const useScrollToTop = () => {
    const location = useLocation()
    const history = useHistory()

    useEffect(() => {
        /*
        Scrollearemos al top siempre y cuando la location no tenga un search y se vengad de otra pagina (metodo PUSH), ya que puede haber un elemento donde se haga
        el foco, el caso del buscador de itinerarios en la pagina /itinerarios
        */
        if (location.search || history.action === 'REPLACE') {
            return
        }

        window.scrollTo({ behavior: 'smooth', top: 0 })
    }, [location])
}

export default useScrollToTop
